/**
 * better to ask Felix if you're not sure if something is general term or not
 * do not mistake with "simple" translations like "submit" or "cancel"
 * never use for composition
 *
 * generalTerm translations are something, which are specific to project "domain" or "project"
 * "common" translations are everything, which can be reused across different projects
 *
 * TODO: extract "common" above this object in order to reuse some translations
 */
export const generalTerm = {
  // common
  // do not mistake with "Load ID"
  // "Load ID" might or might not be indexing field for database
  // "Load Identifier" is a customer-written "comment" or "description" which they later use for internal usage
  loadIdentifier: 'Chargenbezeichnung',
  date: 'Datum',
  name: 'Name',
  description: 'Beschreibung',
  event: 'Ereignis | Ereignisse',
  mappedPT9800user: 'Der gemappte Protherm Benutzer',
  // equipment || asset
  asset: 'Anlage',
  assetId: 'Anlagen-Id',
  assetType: 'Anlagentyp',
  customer: 'Kunde',
  composition: 'Zusammensetzung',
  element: 'Element | Elemente',
  root: 'Wurzel | Wurzeln',
  location: 'Standort | Standorte',
  locationId: 'Standort-Id',
  // job || load
  job: 'Charge | Chargen',
  jobDisplayName: 'Chargen-Nr.',
  jobStartedAtUtc: 'Startzeit',
  jobFinishedAtUtc: 'Endzeit',
  // sensor || meaning || signal
  sensor: 'Sensor',
  signal: 'Signal | Signale',
  unit: 'Einheit | Einheiten',
  recipe: 'Rezept | Rezepte',
  scadaType: 'Scadatyp',
  materialSystemList: 'Werkstoffsysteme',
  measure: 'Messwert | Messwerte',
  setpoint: 'Sollwert | Sollwerte',
  reportId: 'Berichts-Nr.',
  report: 'Bericht',
  reporter: 'Berichterstatter',
  jobId: 'Chargen-Id',
  partId: 'Teile-Id',
  part: 'Teil',
  step: 'Schritt',
  recipeStep: 'Rezeptschritt',
  material: 'Werkstoff',
  drawingReference: 'Zeichnungsreferenz',
  displayName: 'Name',
  preset: 'Voreinstellungen',
  materialCalculationModel: 'Werkstoffberechnungsmodell',
  data: 'Daten',
  chart: 'Diagramm | Diagramme',
  austenite: 'Austenit',
  gasComposition: 'Gaszusammensetzung',
  generalInformation: 'Allgemeine Informationen',
  limitMinus: 'Limit -',
  limitPlus: 'Limit +',
  envelope: 'Grenze',
  email: 'E-Mail',
  sms: 'SMS',
  upload: 'Hochladen',
  orientation: 'Ausrichtung',
  height: 'Höhe',
  width: 'Breite',
  title: 'Titel',
  send: 'Send',
  fullName: 'Vollständiger Name',
  production: 'Produktion',
  color: 'Farbe',
  dataSourceId: 'Datenquelle',
  dataSourceReference: 'Referenz in der Datenquelle',

  // TODO: migrate to "common"
  createdAt: 'Erstellt am',
  createdBy: 'Erstellt von',
  deletedAt: 'Gelöscht am',
  deletedBy: 'Gelöscht von',
  deleted: 'Gelöscht',
  lastModifiedAt: 'Geändert am',
  lastModifiedBy: 'Geändert von',
  revision: 'Revision',
  showDeleted: 'Gelöschte anzeigen',
  overwrite: 'Überschreiben',
  requirement: 'Anforderung',
  result: 'Ergebnis',

  schaefflerDiagram: 'Schäffler-Diagramm',
  CCTDiagram: 'CCT-Diagramm',
  temperingCurveDiagram: 'Anlasskurve',
  jominyDiagram: 'Jominy-Kurve',
  profileChart: 'Profil-Chart',
  processValuesChart: 'Prozesswert-Chart',
  profileTable: 'Profiltabelle',

  carbonPotential: 'C-Pegel Status',
  nitrogenPotential: 'Stickstoffpotential',
  surfaceCarbon: 'Oberflächenkohlenstoff',
  surfaceNitrogen: 'Oberflächenstickstoff',
  surfaceCarbide: 'Oberflächenkarbide',

  recipeStage: 'Rezeptschritt',
  component: 'Komponente | Komponenten',
  area: 'Bereich | Bereiche',
  automat: 'Automat | Automaten',
  equipment: 'Anlage | Anlagen',
  equipmentGroup: 'Anlagengruppe | Anlagengruppen',
  sparePart: 'Ersatzteil | Ersatzteile',
  manufacturer: 'Hersteller',
  partNumber: 'Teile-Nr.',
  chamber: 'Kammer | Kammern',
  company: 'Unternehmen | Unternehmen',
  heatTreatmentCapability: 'Wärmebehandlungsfähigkeit | Wärmebehandlungsfähigkeiten',
  preference: 'Präferenz | Präferenzen',
  heatTreatmentProcess: 'Wärmebehandlungsprozess | Wärmebehandlungsprozessen',

  processFlow: 'Ablauf | Abläufe',

  machine: 'Maschine | Maschinen',
  zone: 'Zone | Zonen',

  // Diffusion / simulation inputs — shared by the Diffusion Inputs panel
  // (form-pt9800-diffusion-inputs.vue) and the /simulator page. Wording mirrors the simulator.
  alloyFactor: 'Legierungsfaktor C',
  carbonContent: 'Kernkohlenstoffgehalt',
  carbideLimit: 'Carbidgrenze',
  carbonMonoxide: 'Carbon monoxide CO',
  hydrogen: 'Hydrogen H₂',
  quenchingIntensity: 'Abschreckintensität',
  representativeDiameter: 'Maßgeblicher Wärmebehandlungsdurchmesser (DIN 17211)',
  requiredHardness: 'Grenzhärte',
  grainSize: 'ASTM-Korngrößenzahl',
  endTemperature: 'Endtemperatur',
  carburizingDepth: 'Aufkohlungstiefe',
  nitridingDepth: 'Nitriertriefe (NHD)',
  referenceCarbon: 'Grenzkohlenstoffgehalt',
  targetSurfaceCarbon: 'Soll-Rand-C',
};

// used in tables or other places where you need to filter by general term
export const generalTermFilter = {
  asset: 'Suche Anlage',
};
